import { render } from "./CustomerInvoiceCreate.vue?vue&type=template&id=46126592&scoped=true"
import script from "./CustomerInvoiceCreate.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceCreate.vue?vue&type=script&lang=js"

import "./CustomerInvoiceCreate.vue?vue&type=style&index=0&id=46126592&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46126592"]])

export default __exports__